<script lang="ts">
  import {getContext} from 'svelte';
  import {goto} from '@sapper/app';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {IMAGES_V2} from '@/const/images';
  import {envUtil} from '@/helper/env';
  import {mockUtil} from '@/helper/moc';
  import {fullImageUrlFun} from '@/helper/url';
  import {sd} from '@/da';
  import {mc} from '@/core';
  import {fixLink$} from '@/store/lang';
  import {isLogin$, userStatus$} from '@/streams/auth';
  import {userInfo$} from '@/streams/user';
  import {announcementApi} from '@/api/announcement';
  import {openDepositDrawer, preloadNewDepositPortalDrawer} from '@/modules/components/deposit/utils';
  import {gotoRegisterWithRedirect, gotoLoginWithRedirect, setRedirectTarget} from '../util';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import Loadable from '@/widgets/loadable/Loadable.svelte';
  import DownloadDropDown from '../popups/download/DownloadDropDown.svelte';
  import NoticeDropDown from '../popups/notice/NoticeDropDown.svelte';
  import LanguageDropDown from '../popups/language/LanguageDropDown.svelte';
  import {unreadCount$, loadAnnouncement} from '../popups/notice/stream';
  import lang from '../Header.lang';
  import {env} from '@/helper';

  export let isTop = false;
  export let modalUI = false;
  // 是否隐藏登录注册模块
  export let hiddenAccess = false;

  const LG = getContext('LG');
  const isMock = mockUtil.isMock();
  const menus = {
    assets: defineMenuConfig({
      loader: () => import('../popups/assets/AssetsDropDown.svelte'),
    }),
    account: defineMenuConfig({
      loader: () => import('../popups/account/AccountDropDown.svelte'),
    }),
  };
  const fullImageUrl = fullImageUrlFun();
  const placement = 'bottom';
  const modifiers = [
    {
      name: 'preventOverflow',
      options: {
        padding: 20,
      },
    },
  ];

  /** @type { Partial<Record<keyof menus, boolean>> } */
  let loadableStartData = {};
  let isShowBonusIcon = false;

  $: color = 'var(--menu-dark)';
  $: hoverColor = 'var(--menu-dark-hover)';
  $: process.browser && updateIsShowBonusIcon($userInfo$, $userStatus$);

  function handleNoticeEnter() {
    if ($unreadCount$ > 0 && $isLogin$) {
      updateBrowseAnnouncementTime();
    }
  }

  async function updateBrowseAnnouncementTime() {
    const params = {itemKey: 'announcement'};
    const {data, error} = await announcementApi.browseTime(params);
    if (data) {
      loadAnnouncement($isLogin$ ? 'Login' : 'Logout');
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }

  function handleRegisterClick() {
    if (modalUI) {
      mc.send('modal-register', 'startRegister');
    } else {
      const currentPath = window.location.href;
      setRedirectTarget(currentPath);
      gotoRegisterWithRedirect($fixLink$);
    }
  }

  function handleLogInClick() {
    const currentPath = window.location.href;
    setRedirectTarget(currentPath);
    gotoLoginWithRedirect($fixLink$);
  }

  /**
   * @param {{loader: () => Promise<unknown>; mouseenterHandler?: () => void}} config
   */
  function defineMenuConfig(config) {
    return config;
  }

  /**
   * @param {keyof menus} menu
   */
  function handleMouseenterEventAction(menu) {
    return function () {
      loadableStartData = {...loadableStartData, [menu]: true};
      const {mouseenterHandler} = menus[menu] || {};
      if (mouseenterHandler) {
        mouseenterHandler();
      }
    };
  }

  function handleDepositClick() {
    sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_deposit'});
    openDepositDrawer({LG});
  }

  function handleBonusClick() {
    sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_rewards_hub'});
    goto($fixLink$(PATHS.BONUS.pathname) + '?tab=package');
  }

  function updateIsShowBonusIcon(userInfo, userStatus) {
    if (userStatus === 'Logout') {
      isShowBonusIcon = true;
      return;
    }
    if (userInfo && userInfo.createTime) {
      const createTime = userInfo.createTime;
      const day = 1000 * 60 * 60 * 24;
      const cha = Date.now() - (createTime + day * 30);
      if (cha < 0) {
        isShowBonusIcon = true;
        return;
      }
      isShowBonusIcon = false;
    }
  }
</script>

<style lang="scss">
  .login {
    display: inline-block;
    padding: 8px;
    height: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      opacity: 0.8;
    }
  }
  .btn,
  :global(.btn-deposit.primary) {
    display: inline-block !important;
    border-radius: 20px !important;
    padding: 0 16px !important;
    height: 40px !important;
    line-height: 40px !important;
    text-align: center !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    background-color: #0345f5 !important;
    color: #fff !important;
    cursor: pointer !important;
    text-decoration: none !important;
    &:hover {
      opacity: 0.8;
    }
  }
  .top .login {
    background-color: transparent;
    color: #fff;
  }
  .top .btn {
    background-color: #0345f5;
    color: #fff;
  }
  .icon {
    padding: 19px 0;
  }
  .circle {
    top: -4px;
    right: -4px;
    border-radius: 8px;
    padding: 4px;
    min-width: 8px;
    line-height: 8px;
    text-align: center;
    font-style: normal;
    background: #ff6c67;
    color: #fff;
  }
  .assets {
    height: 56px;
    line-height: 56px;
  }
  .icon-con {
    box-sizing: border-box;
    height: 56px;
    &:hover .circle-icon {
      background-color: #202429;
    }
  }
  .top {
    & .icon-con:hover .circle-icon:not(.no-bg) {
      background-color: #202429;
    }
  }
  .circle-icon {
    display: flex;
    align-items: center;
    width: 50px;
    height: 56px;
    text-align: center;
  }
  .split {
    width: 1px;
    height: 20px;
    background: #dbdfe7;
  }
  .top .split {
    background: #333333;
  }
  .menu-bonus {
    transform: translateY(-3px);
  }
  .main :global(.tooltip-wrap .auto-scroll) {
    border-radius: 0 0 12px 12px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  }
</style>

<div class="df">
  <div class="main df fdr aic" class:top={isTop}>
    {#if !env.isJapanSite}
      {#if isShowBonusIcon}
        <Menu noIcon>
          <div class="ph12 mr10 menu-bonus" slot="trigger" on:click={handleBonusClick}>
            <img width="28" height="42" src={IMAGES_V2.BONUS_ICON} alt="bonus" />
          </div>
        </Menu>
      {/if}
      {#if !envUtil.isServer}
        <div class="df aic">
          {#if $isLogin$}
            <Button class="btn-deposit" type="primary" on:click={handleDepositClick}>
              <div class="df aic jcc" on:mouseenter={preloadNewDepositPortalDrawer}>
                <i class="iconfont fw1">&#xe66b;</i>
                <div class="ml8">{LG(lang.Deposit)}</div>
              </div>
            </Button>
            {#if !isMock}
              <Menu width="280px" class="ml10" {placement} {modifiers} {color} hoverColor={color} noIcon on:mouseenter={handleMouseenterEventAction('assets')}>
                <div slot="trigger" class="assets icon-con df aic cp fw1" on:click={() => location.assign($fixLink$(PATHS.ASSETS_OVERVIEW.pathname))}>
                  <div class="circle-icon"><i class="iconfont f1 f24">&#xe743;</i></div>
                </div>
                <Loadable loader={menus.assets.loader} start={loadableStartData.assets} />
              </Menu>
            {/if}
            <Menu width="280px" {placement} {modifiers} {color} hoverColor={color} noIcon on:mouseenter={handleMouseenterEventAction('account')}>
              <div slot="trigger" class="account icon-con df aic cp fw1" on:click={() => location.assign($fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname))}>
                <div class="circle-icon"><i class="iconfont f1 f24">&#xe768;</i></div>
              </div>
              <Loadable loader={menus.account.loader} start={loadableStartData.account} />
            </Menu>
          {:else if !hiddenAccess}
            <div class="login mr10 T2 ga home-login" data-gac="user.login" data-gaa="link_click" data-gal="header.login" on:click={handleLogInClick}>
              <span>{LG(lang.LogIn)}</span>
            </div>
            <div class="btn ga home-register mr10" data-gac="user.register" data-gaa="link_click" data-gal="header.register" on:click={handleRegisterClick}>
              <span>{LG(lang.SignUp)}</span>
            </div>
          {/if}
        </div>
      {/if}
      <Menu {placement} {modifiers} {color} hoverColor={color} noIcon>
        <div slot="trigger" class="icon-con df aic cp fw1">
          <div class="circle-icon"><i class="iconfont f1 f24">&#xe751;</i></div>
        </div>
        <DownloadDropDown />
      </Menu>
    {/if}
    {#if $isLogin$}
      <Menu {placement} {modifiers} {color} hoverColor={color} noIcon on:mouseenter={handleNoticeEnter}>
        <div slot="trigger" class="icon-con df aic cp fw1">
          <div class="circle-icon"><i class="iconfont f1 f24">&#xe74c;</i></div>
          <span class="icon df pr">
            {#if $isLogin$ && $unreadCount$ > 0}
              <i class="circle pa f10">{$unreadCount$}</i>
            {/if}
          </span>
        </div>
        <NoticeDropDown />
      </Menu>
    {/if}
    <Menu {placement} {modifiers} {color} hoverColor={color} noIcon>
      <div slot="trigger" class="icon-con df aic cp fw1">
        <div class="circle-icon"><i class="iconfont f1 f24">&#xe762;</i></div>
      </div>
      <LanguageDropDown />
    </Menu>
  </div>
</div>
